import { Stack, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useFinancialContext } from './FinancialContext';
import ContractDetailsPage from './components/pages/ContractDetailsPage';
import ContractsPage from './components/pages/ContractsPage';

const Financial = () => {
  const context = useFinancialContext();
  const tabChangeEvent = (index: number) => {
    if (context.onChangeTab) {
      context.onChangeTab(index);
    }
  };
  return (
    <Stack>
      <Tabs
        index={context.tabIndex}
        onChange={(index) => tabChangeEvent(index)}
      >
        <TabPanels>
          <TabPanel p="0">
            <ContractsPage />
          </TabPanel>
          <TabPanel p="0">
            <ContractDetailsPage />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Stack>
  );
};

export default Financial;
